module.exports = __webpack_public_path__ + "img/q4-10-active.fb7a2765.png";